export const TABLE_COLUMNS = [
  {
    Header: "Наименование административной процедуры",
    accessor: "name",
  },
  {
    Header:
      "Документы и (или) сведения, предоставляемые заинтересованным лицом для осуществления АП",
    accessor: "docs",
  },
  {
    Header:
      "Вид и размер платы, взимаемой при осуществлении административной процедуры",
    accessor: "sum",
  },
  {
    Header: "Максимальный срок осуществления процедуры",
    accessor: "time1",
  },
  {
    Header:
      "Срок действия справки или другого документа, выдаваемого при осуществлении АП",
    accessor: "time2",
  },
];
